import axios from 'axios'
import Cookies from "js-cookie"

export function searchPostalCode(CEP, payload, errorPayload = () => { }) {
    axios.get(`https://viacep.com.br/ws/${CEP}/json/`)
        .then(resp => {
            payload(resp.data)
        })
        .catch(error => errorPayload(error))
}
export async function viaCep(cep) {
    return axios.get(`https://viacep.com.br/ws/${cep}/json/`)
}
export async function receitaws(cnpj) {
    //https://receitaws.com.br/v1/cnpj/83325498000190
    return axios.get(`https://receitaws.com.br/v1/cnpj/${cnpj}`)
}
export function validateCPF(cpf) {
    if(typeof cpf !== "string") return false
    cpf = cpf.replace(/[^\d]/g, ''); // Remove caracteres não numéricos
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

    let soma = 0, resto;
    for (let i = 1; i <= 9; i++) soma += parseInt(cpf[i - 1]) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf[9])) return false;

    soma = 0;
    for (let i = 1; i <= 10; i++) soma += parseInt(cpf[i - 1]) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(cpf[10]);
}
export function validateCNPJ(cnpj) {
    if(typeof cnpj !== "string") return false
    cnpj = cnpj.replace(/[^\d]/g, ''); // Remove caracteres não numéricos
    if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0, pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros[tamanho - i]) * pos--;
        if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos[0])) return false;

    tamanho++;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros[tamanho - i]) * pos--;
        if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    return resultado === parseInt(digitos[1]);
}
export function formatDocument(document = "") {
    if (!document) {
        return ""
    }
    if (document.length === 11) {
        return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4")
    } else if (document.length === 14) {
        return document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5")
    }
}
export function validatePhone(phoneNumber) {
    return (/^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/).test(phoneNumber)
}
export function validateEmail(email) {
    return (/^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/).test(email)
}
export function formatPhoneNumber(phone = "") {
    if (phone.length === 10) {
        return phone.replace(/(\d{2})(\d{4})(\d{4})/g, "($1) $2-$3")
    } else if (phone.length === 11) {
        return phone.replace(/(\d{2})(\d{5})(\d{4})/g, "($1) $2-$3")
    }
}
export function formatCurrencyValue(value = "") {
    if (value === undefined || value === null) {
        return
    }
    return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    })
}
export function decimalFormat(double = 0, precision = 4) {
    let [integer, cents] = double.toString().split('.')
    if (!cents) {
        cents = ''.padStart(precision, "0")
    }
    return parseFloat(`${integer}.${cents.substring(0, precision)}`)
}
export function formatDate(datetime, withDatetime = true) {
    if (withDatetime) {
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        };
        return new Date(datetime).toLocaleDateString('pt-BR', options)
    } else {
        return new Date(datetime).toLocaleDateString('pt-BR')
    }

}
export function donwloadBase64(filename, fileExtersion, mimeType, data) {
    const LinkSource = `data:${mimeType};base64,${data}`;
    const DownloadLink = document.createElement('a');
    DownloadLink.href = LinkSource;
    DownloadLink.download = `${filename}.${fileExtersion}`;
    DownloadLink.click();
}
export function getCookieByName(name) {
    return Cookies.get(name)
}
export function setCookieByName(name, value) {
    Cookies.set(name, value, { secure: true, expires: 365 })
}
export function clearAllCookies() {
    for (let k of Object.keys(Cookies.get())) {
        Cookies.remove(k)
    }
}
export function checkIfBranchExists() {
    let branch = window.localStorage.getItem("easygestorweb_current_branch")
    if (branch) {
        branch = JSON.parse(branch || {})
        if (branch.id === "09ef7488-d439-40da-b384-5ccde14ffe8a") {
            window.location.href = "/branches/create"
        }
    } else {
        window.location.href = "/branches/create"
    }
}
export function setLocalStorageItem(key, value, stringfy = true) {
    if (process.env.NODE_ENV == "development") {
        key = `${process.env.NODE_ENV}:${key}`
    }
    if (stringfy) {
        value = JSON.stringify(value)
    }
    window.localStorage.setItem(key, value)
}
export function getLocalStorageItem(key = "", parse = true) {
    if (process.env.NODE_ENV == "development") {
        key = `${process.env.NODE_ENV}:${key}`
    }
    let data = window.localStorage.getItem(key) || null
    if (data) {
        if (parse) {
            data = JSON.parse(data)
        }
    }
    return data
}
export function deleteLocalStorageItem(key = "", parse = true) {
    if (process.env.NODE_ENV == "development") {
        key = `${process.env.NODE_ENV}:${key}`
    }
    window.localStorage.removeItem(key)
    return true
}
export function showSnackBar(message, bg = "danger", timeout = 5000) {
    const snackbar = document.getElementById("awesome-snackbar")
    snackbar.classList.add("show")
    snackbar.classList.add(`bg-${bg}`)
    snackbar.classList.add("text-white")
    snackbar.classList.add("text-center")
    snackbar.innerText = message

    setTimeout(() => {
        snackbar.classList.remove("show")
        snackbar.classList.remove(`bg-${bg}`)
        snackbar.classList.remove("text-white")
        snackbar.classList.remove("text-center")
        snackbar.innerText = ""
    }, timeout)
}
export function getBranchUserData() {
    let branch = window.localStorage.getItem("easygestorweb_current_branch")
    console.log(branch)
    if (branch) {
        branch = JSON.parse(branch)

        if (branch.is_fake) {
            try {
                let user = window.localStorage.getItem("easygestorweb_userdata")
                user = JSON.parse(user)
                return `Email: ${user.email} (Sem empresa)`
            } catch (error) {
                return ""
            }
        }

        let cpfCnpj = ''
        let name = ''
        if (branch.company) {
            name = branch.company.fancy_name
            cpfCnpj = branch.company.cnpj
        } else {
            cpfCnpj = branch.individual.cpf
            name = branch.name
        }
        cpfCnpj = formatDocument(cpfCnpj)
        return `Nome: ${name} - CPF/CNPJ: ${cpfCnpj} - Email: ${branch.email}`
    } else {
        try {
            let user = window.localStorage.getItem("easygestorweb_userdata")
        user = JSON.parse(user)
        return `Email: ${user.email} (Sem empresa)`
        } catch (error) {
            return ""
        }
    }
} ''


export function DifferenceBetweenDatesInDays(date1, date2 = new Date()) {
    let difference = date1.getTime() - date2.getTime();
    difference = Math.ceil(difference / (1000 * 3600 * 24));

    return difference
}

export function parseQueryString(qs) {
    let params = {}
    for (let x of qs.split("&")) {
        const [k, v] = x.split("=")
        params[k] = v
    }
    return params
}

export function CutieflyCheckVersion(){
    const storagedVersion = getCookieByName("cutiefly")
    const currentVersion = process.env.REACT_APP_BUILD_VERSION
    if (!storagedVersion) {
        setCookieByName("cutiefly", currentVersion)
    } else {
        if (storagedVersion !== currentVersion) {
            const cookies = {}
            const storages = {}
            for(let cookie of ["branch_owner_id", "branch_owner_name", "branch_state_name", "role", "access", "refresh", "username", "branch_count"]){
                cookies[cookie] = getCookieByName(cookie)
            }
            clearAllCookies()
            for(let cookie of Object.keys(cookies)){
                setCookieByName(cookie, cookies[cookie])
            }
            for(let storage of ["easygestorweb_current_branch", "easygestorweb_refresh_token", "easygestorweb_apikey", "easygestorweb_userdata"]){
                storages[storage] = localStorage.getItem(storage)
            }
            localStorage.clear()
            for(let storage of Object.keys(storages)){
                localStorage.setItem(storage, storages[storage])
            }
            window.location.reload(true)
        }
    }
}

export function exportCSVData(filename="", header="", data=""){
    data = [].concat([header]).concat(data)
    filename = `${filename}.csv`
    console.debug(filename)
    console.debug(data)
    const csvContent = data.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    if (navigator.msSaveBlob) {
        // Para o Internet Explorer
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
}
export function formateCurrentDate(){
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}


export function callSupport(text=""){
    window.open( `https://api.whatsapp.com/send/?phone=5511966466526&text=${text}` )

}
export function increaseMonths(date, months) {
    let dates = [new Date(date)];
    let currentDate = new Date(date);
    let originalDay = date.getDate();
    let isEndOfMonth = originalDay === new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

    for (let i = 1; i < months; i++) {
        const nextMonth = currentDate.getMonth() + 1;
        const nextYear = currentDate.getFullYear() + Math.floor(nextMonth / 12);
        const lastDayOfNextMonth = new Date(nextYear, (nextMonth % 12) + 1, 0).getDate();

        let newDay = isEndOfMonth ? lastDayOfNextMonth : Math.min(originalDay, lastDayOfNextMonth);
        const newDate = new Date(nextYear, nextMonth % 12, newDay);

        dates.push(newDate);
        currentDate = newDate;
        isEndOfMonth = newDay === lastDayOfNextMonth;
    }

    return dates;
}



// WEBPACK FOOTER //
// ./src/utils/index.js